import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDeviceInfo } from "../../../Services";
import { Station, StationTerminal } from "../../../Definitions/newSectionModalInterfaces";
import { ModalLvl3 } from "../..";
import { useModalContext } from "../../LocationFeeder/_LocationFeeder/newSectionModalContext";

const NewEsfWfSectionModalLvl3: React.FC = () => {
  const { state: { domain, connection, section } } = useModalContext()
  const { t } = useTranslation()

  const stations = { ...section, contents: section.contents as Station[] };

  const { data: deviceInfoState } = useDeviceInfo(connection);

  // #region | Additional fields
  const fields: { key: StationTerminal["__terminalType"], label: string, condition?: (station: Station) => boolean }[] = [
    { key: "feederOutput", label: t("esfWalkThroughPages.newSection.feederOutput", { defaultValue: "Feeder Output" }) },
    { key: "feederInput", label: t("esfWalkThroughPages.newSection.feederInput", { defaultValue: "Feeder Input" }) },
    { key: "gateMotorOutput", label: t("esfWalkThroughPages.newSection.gateMotorOutput", { defaultValue: "Gate Motor Output" }) },
    { key: "gateMotorInput", label: t("esfWalkThroughPages.newSection.gateMotorInput", { defaultValue: "Gate Motor Input" }) },
    { key: "gateSensor", label: t("esfWalkThroughPages.newSection.gateSensor", { defaultValue: "Gate Sensor" }) },

    {
      key: "waterOutput",
      label: t("esfWalkThroughPages.newSection.waterOutput", { defaultValue: "Water Output" }),
      condition: (station: Station) => station.terminals["waterOutput"]?.port != null
    },
    {
      key: "buttonInput",
      label: t("esfWalkThroughPages.newSection.buttonInput"),
      condition: (station: Station) => station.terminals["buttonInput"]?.port != null
    },
    {
      key: "readerInput",
      label: t("motorSpecs.terminalTypes.rfidReaderInput", { defaultValue: "RFID Reader Input" })
    }
  ];
  // #endregion

  // Get devices to find i/o name
  const deviceInfo = useMemo(() => {
    if (deviceInfoState[domain]) {
      return deviceInfoState[domain].data.map((deviceInfo) => ({ id: deviceInfo.device_id, name: deviceInfo.name, systemId: deviceInfo.system_assignment, type: 1 }))
    }
    return []
  }, [deviceInfoState, domain])

  return (
    <ModalLvl3
      locations={stations.contents}
      section={section}
      rows={section.rows}
      columns={section.columns}
      deviceInfo={deviceInfo}
      additionalFields={fields}
    />
  );
}

export default NewEsfWfSectionModalLvl3
